export const verbs = [
  'attenuating',
  'adjusting',
  'loading',
  'calibrating',
  'rerouting',
  'detecting',
  'resequencing',
  'supercharging'
]
export const adverbs = [
  'fore ',
  'aft',
  'starboard',
  'port',
  'central',
  'dorsal',
  'ventral'
]

export const adjectives = [
  'transitory',
  'polaron',
  'parabolic',
  'ventral',
  'neogenic',
  'nadion',
  'optronic',
  'higgs',
  'tactical',
  'interphasic',
  'luvetric',
  'thoron',
  'verteron',
  'dermatiraelian',
  'lexorian',
  'ablative',
  'polarity',
  'subspace',
  'electroplasma'
]

export const nouns = [
  'decompilers',
  'plate',
  'plasma fluid',
  'distribution',
  'warp core',
  'subspace detectors',
  'transporter',
  'magnetic wave',
  'sensor',
  'resistance',
  'particle',
  'laser',
  'containment field',
  'thrust',
  'vacuum',
  'isotope',
  'navigational',
  'data',
  'conduit',
  'neurotransmitters',
  'gamma ray',
  'subharmonic oscillation',
  'dynoscanner'
]

export const sub_nouns = [
  'pattern',
  'polarity',
  'detector',
  'buffer',
  'matrix',
  'sequencer',
  'assembly',
  'housing',
  'chamber',
  'network',
  'bank',
  'thruster'
]
